import React from 'react';
import './style.scss';
import profileCardCoin from '../../../images/profile-card-coin.png';

export const Coins = ({coins, big}) => {
  return <span className={'app-coins' + (big ? ' app-coins_big' : ' app-coins_small')}>
    <img className="app-coins--icon" src={profileCardCoin} alt={''}/>
    <span className="app-coins--value">{coins.toLocaleString('en-US')}</span>
  </span>;
}